export const DEFAULT_ANIMATION_SPEED = '110%';
